import store from '../modules/store'
import {selectUserManuallyVisibleWidgetList, selectUserVisibleWidgetList} from '../modules/security/state/auth/selector'

const currentUserHasAccess = (widgetId) => {
    const state = store.getState()

    const visibleWidgetList = selectUserVisibleWidgetList(state)
    const visibleManuallyAddedWidgetList = selectUserManuallyVisibleWidgetList(state)

    return visibleWidgetList.includes(widgetId) || visibleManuallyAddedWidgetList.includes(widgetId)
}

export default currentUserHasAccess



// WEBPACK FOOTER //
// ./src/util/widget-helper.js